// Admin email buttons open Gmail's compose window (shop account) instead of the OS mail app.
const ACCOUNT = "info@maggierecords.com";

export function gmailCompose({ to = "", subject = "", body = "" } = {}) {
  const q = new URLSearchParams({ view: "cm", fs: "1", authuser: ACCOUNT, to, su: subject, body });
  return `https://mail.google.com/mail/?${q.toString()}`;
}
